import { Tolgee, DevTools } from '@tolgee/vue';
import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch } from '@tolgee/web';

const isDev = import.meta.env.VITE_ENV === 'development';

const tolgee = Tolgee().use(FormatIcu());

if (isDev) {
  tolgee.use(DevTools());
} else {
  tolgee.use(
    BackendFetch({
      prefix: `${import.meta.env.VITE_API_URL}/i18n`,
      fallbackOnFail: true
    })
  );
}

const staticData = {
  uk: (_) => import('./assets/i18n/uk.json'),
  en: (_) => import('./assets/i18n/en.json')
};

export default tolgee.init({
  language: 'uk',
  availableLanguages: ['uk', 'en'],
  preloadFallback: false,
  staticData,

  ...(isDev && {
    apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY
  })
});
